import { render, staticRenderFns } from "./event-preview.vue?vue&type=template&id=2346f135"
import script from "./event-preview.vue?vue&type=script&lang=js"
export * from "./event-preview.vue?vue&type=script&lang=js"
import style0 from "./event-preview.vue?vue&type=style&index=0&id=2346f135&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2346f135')) {
      api.createRecord('2346f135', component.options)
    } else {
      api.reload('2346f135', component.options)
    }
    module.hot.accept("./event-preview.vue?vue&type=template&id=2346f135", function () {
      api.rerender('2346f135', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/event-preview.vue"
export default component.exports